import React from "react";
import { MainLayout } from "../../../modules/layout/main-layout/main-layout";
import "./index.scss";

interface GuestErrorViewProps {
  isExpiredLinkError?: boolean;
}

const GuestErrorView = ({ isExpiredLinkError = false }: GuestErrorViewProps) => {
  return (
    <MainLayout>
      <div className="guest-error-wrapper">
        <main className="guest-error-main">
          <div className={isExpiredLinkError ? "guest-error-expired-panel" : "guest-error-card"}>
            {isExpiredLinkError ? (
              <>
                <div className="guest-error-expired-icon" aria-hidden="true">
                  !
                </div>
                <h1 className="guest-error-expired-heading">Hi, it looks like your link has expired from too many tries.</h1>

                <div className="guest-error-expired-details">
                  <p className="guest-error-expired-text">If you are still having issues:</p>
                  <p className="guest-error-expired-text">
                    Please contact your Administrator
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="guest-error-warning-icon" aria-hidden="true">
                  !
                </div>
                <div className="guest-error-message">Authentication failed. Please check your link.</div>
              </>
            )}
          </div>
        </main>
      </div>
    </MainLayout>
  );
};

export default GuestErrorView;
